import { render } from "./productAddNewSizeDialog.vue?vue&type=template&id=9b2ea3a2"
import script from "./productAddNewSizeDialog.vue?vue&type=script&lang=js"
export * from "./productAddNewSizeDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__